// noinspection DuplicatedCode

import React, {useEffect, useState} from "react";
import {useDispatch, useSelector} from "react-redux";
import {useNavigate} from "react-router-dom";

import {alertService} from "../../../services/AlertService";

import TableCard from "../../../components/tablecard/TableCard";
import ModalForm from "../../../components/modal/form/ModalForm";

import {getGudang, gudangSelector, insertGudang, updateGudang,} from "./gudangSlice";

import {Colors} from "../../../assets/Colors";

const GudangIndexPage = ({}) => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const [firstLoading, setFirstLoading] = useState(false);
    const [start, setStart] = useState(0);
    const [count, setCount] = useState(5);
    const [page, setPage] = useState(1);
    const [maxPage, setMaxPage] = useState(0);
    const [search, setSearch] = useState("");
    const [searchFetch, setSearchFetch] = useState(false);
    const [insertFetch, setInsertFetch] = useState(false);
    const [updateFetch, setUpdateFetch] = useState(false);
    const [showModalAdd, setShowModalAdd] = useState(false);
    const [showModalEdit, setShowModalEdit] = useState(false);
    const [currentData, setCurrentData] = useState({});

    const gudang = useSelector(gudangSelector);

    useEffect(() => {
        dispatch(
            getGudang({
                start: start,
                count: count,
                search: "",
            })
        );
    }, []);

    useEffect(() => {
        if (search !== "" && gudang.isGetSuccess && !gudang.isGetFetching) {
            let calc = gudang?.count - 1;
            if (calc === 0) {
                calc = 1;
            }

            if (calc % count === 0) {
                calc = calc + 1;
            }
            let tempMaxPage = gudang.data ? Math.ceil(calc / count) : 1;
            setSearchFetch(false);
            setMaxPage(tempMaxPage);
        } else if (search === "" && gudang.isGetSuccess && !gudang.isGetFetching) {
            let calc = gudang?.count - 1;
            if (calc === 0) {
                calc = 1;
            }

            if (calc % count === 0) {
                calc = calc + 1;
            }
            let tempMaxPage = gudang.data ? Math.ceil(calc / count) : 1;
            setSearchFetch(false);
            setMaxPage(tempMaxPage);
        }

        if (
            !gudang?.isGetFetching &&
            gudang.isGetSuccess &&
            maxPage === 0 &&
            firstLoading === false
        ) {
            let calc = gudang?.count - 1;
            if (calc === 0) {
                calc = 1;
            }

            if (calc % count === 0) {
                calc = calc + 1;
            }
            let tempMaxPage = gudang.data ? Math.ceil(calc / count) : 1;
            setMaxPage(tempMaxPage);
            setFirstLoading(true);
            dispatch(
                getGudang({
                    start: start,
                    count: count,
                    search: search,
                })
            );
        }

        if (insertFetch) {
            setInsertFetch(false);
            if (gudang.isGetSuccess) {
                alertService.success(gudang.message, {
                    autoClose: true,
                    keepAfterRouteChange: false,
                });
                dispatch(
                    getGudang({
                        start: start,
                        count: count,
                        search: search,
                    })
                );
            }
        }

        if (updateFetch) {
            setUpdateFetch(false);
            if (gudang.isUpdateSuccess) {
                alertService.success(gudang.message, {
                    autoClose: true,
                    keepAfterRouteChange: false,
                });
                dispatch(
                    updateGudang({
                        start: start,
                        count: count,
                        search: search,
                    })
                );
            }
        }
    });

    // function handleGetGudang(params) {
    //   return dispatch(getGudang(params));
    // }

    function handleInsertGudang(param) {
        setInsertFetch(true);
        const params = {
            NamaGudang: param.inputOneValue,
            CategoryID: param.dropDownGudangValue,
        };

        dispatch(insertGudang(params));
    }

    function handleUpdateGudang(param) {
        setUpdateFetch(true);

        const params = {
            NamaGudang: param.inputOneValue,
            GudangID: currentData.GudangID,
            status: param.status,
            CategoryID: param.dropDownGudangValue,
        };
        dispatch(updateGudang(params));
    }

    function handleSearch(searchValue) {
        let params = {
            start: 0,
            count: 5,
            search: searchValue,
        };
        dispatch(getGudang(params));

        setStart(0);
        setCount(5);
        setSearch(searchValue);
        setSearchFetch(true);
    }

    function handleUpdatePage(newPage) {
        let newStart = newPage * count - count;

        let params = {
            start: newStart,
            count: count,
            search: search,
        };
        dispatch(getGudang(params));

        setPage(newPage);
        setStart(newStart);
    }

    function handleUpdateCount(newCount) {
        let calc = gudang.count - 1;
        if (calc === 0) {
            calc = 1;
        }

        let params = {
            start: newCount === "-1" ? 0 : start,
            count: newCount === "-1" ? gudang.count : newCount,
            search: search,
        };
        dispatch(getGudang(params));

        setPage(1);
        setCount(newCount === "-1" ? gudang.count : newCount);
        setStart(newCount === "-1" ? 0 : start);
        setMaxPage(newCount === "-1" ? 1 : Math.ceil(calc / newCount));
    }

    function handleCurrentData(values) {
        setCurrentData(values);
    }

    function handleModal(status) {
        setShowModalAdd(status.showModalAdd);
        setShowModalEdit(status.showModalEdit);
    }

    if (!firstLoading) {
        return <div>loading</div>;
    } else {
        return (
            <div className="md:ml-64">
                <div
                    style={{background: Colors.primary}}
                    className="pt-14 pb-16 px-3 md:px-8 h-auto"
                >
                    <div className="container mx-auto max-w-full">
                        <div className="grid grid-cols-1 lg:grid-cols-2 xl:grid-cols-4"></div>
                    </div>
                </div>

                <div className="px-3 md:px-8 h-auto -mt-32">
                    <div className="container mx-auto max-w-full">
                        <div className="grid grid-cols-1 px-4">
                            <TableCard
                                backButton={true}
                                backUrl={"master"}
                                handleSearch={handleSearch}
                                searchPlaceholder="Location Used"
                                updatePage={handleUpdatePage}
                                updateCount={handleUpdateCount}
                                currentData={handleCurrentData}
                                currentPage={page}
                                maxPage={maxPage}
                                tableTitle="Master Location Used"
                                tableData={gudang.data}
                                colOneTitle="ID"
                                colOneData="GudangID"
                                colTwoTitle="Nama Location Used"
                                colTwoData="NamaGudang"
                                colThreeTitle="Kelompok"
                                colThreeData="CategoryName"
                                status="Status"
                                fetching={gudang.isGetFetching}
                                modal={handleModal}
                                editEnabled={true}
                            />
                        </div>
                    </div>
                </div>
                {showModalAdd && (
                    <ModalForm
                        dropDownGudang={true}
                        showModal={showModalAdd}
                        addEnabled={true}
                        modal={handleModal}
                        modalTitle="Tambah Location Used"
                        inputOneTitle="Nama Location Used"
                        inputOneValue=""
                        dropDownGudangValue=""
                        submitButtonTitle="Submit"
                        handleSubmit={handleInsertGudang}
                    />
                )}
                {showModalEdit && (
                    <ModalForm
                        dropDownGudang={true}
                        showModal={showModalEdit}
                        editEnabled={true}
                        id={currentData.GudangID}
                        modal={handleModal}
                        modalTitle="Ubah Location Used"
                        inputOneTitle="Nama Location Used"
                        dropDownGudangValue={currentData.CategoryID}
                        inputOneValue={currentData.NamaGudang}
                        status={currentData.Status}
                        submitButtonTitle="Submit"
                        handleSubmit={handleUpdateGudang}
                    />
                )}
            </div>
        );
    }
};

export default GudangIndexPage;
